export default "__VITE_ASSET__BZok9onZ__"